// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1BKJGkHI6s0mrThIEBPecT{color:#111;margin-bottom:1.6rem;margin-top:.4rem}._38SHPyZDfT8pG62ANx0k-P{margin:3.2rem 0}.mL-kQhq9oeH1DQHlvMRUA{border-radius:.4rem;display:block;min-height:10rem;overflow:hidden;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title1": "_1BKJGkHI6s0mrThIEBPecT",
	"imageWrapper": "_38SHPyZDfT8pG62ANx0k-P",
	"image": "mL-kQhq9oeH1DQHlvMRUA"
};
module.exports = ___CSS_LOADER_EXPORT___;
